import React from "react";
import Home from "./Home";
import { Routes, Route } from "react-router-dom";

import TopicDetailTab from "./TopicDetailTab";
import Detail from "./Detail";
import NewDetail from "./NewDetail";
import Empowering from "./Empowering/Empowering";
import AllEpisode from "./AllEpisode/AllEpisode";
import ShortReels from "./ShortReels/ShortReels";

const AppRouter = () => {
  return (
    <Routes>
    <Route
      path="/parikshapecharcha2025/:episodeId/:type/:id"
      element={<NewDetail />}
    />
    <Route
      path="/parikshapecharcha2025/:type/:id"
      element={<NewDetail />}
    />
    <Route
      exact
      path="/parikshapecharcha2025/allepisode/:id"
      element={<AllEpisode />}
    />
    <Route
      exact
      path="/parikshapecharcha2025/allepisode"
      element={<AllEpisode />}
    />
    <Route exact path="/parikshapecharcha2025" element={<Empowering />} />
    <Route exact path="/shortreels" element={<ShortReels />} />
    <Route exact path="/topic/:topicid" element={<TopicDetailTab />} />
    <Route exact path="/:lang/:id" element={<Detail />} />
    <Route exact path="/" element={<Home />} />
  </Routes>
  
  );
};

export default AppRouter;
